import React, { useState } from "react";

const RapidEntryScreen = ({ EntryScreenComponent }) => {
  // User selectable unique id for patient
  const [rapidPatientUniqueId, setRapidPatientUniqueId] = useState("");
  const [rapidPatientFullName, setRapidPatientFullName] = useState("");
  const [rapidEntryAction, setRapidEntryAction] = useState("");

  // Value for storing the id of an existing patient, if save_to_existing is selected.
  const [selectedExistingPatientId, setSelectedExistingPatientId] =
    useState("");

  // Field warnings.
  const [rapidPatientUniqueIdWarning, setRapidPatientUniqueIdWarning] =
    useState(false);

  const [rapidPatientFullNameWarning, setRapidPatientFullNameWarning] =
    useState(false);

  return (
    <div>
      <EntryScreenComponent
        rapidEntry={true}
        rapidPatientUniqueId={rapidPatientUniqueId}
        setRapidPatientUniqueId={setRapidPatientUniqueId}
        rapidPatientFullName={rapidPatientFullName}
        setRapidPatientFullName={setRapidPatientFullName}
        selectedExistingPatientId={selectedExistingPatientId}
        setSelectedExistingPatientId={setSelectedExistingPatientId}
        rapidEntryAction={rapidEntryAction}
        setRapidEntryAction={setRapidEntryAction}
        // Field warnings.
        rapidPatientUniqueIdWarning={rapidPatientUniqueIdWarning}
        setRapidPatientUniqueIdWarning={setRapidPatientUniqueIdWarning}
        rapidPatientFullNameWarning={rapidPatientFullNameWarning}
        setRapidPatientFullNameWarning={setRapidPatientFullNameWarning}
      />
    </div>
  );
};

export default RapidEntryScreen;
